exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tipsBox[data-v-6d8266d4] {\n  display: inline-block;\n  font-size: 13px;\n  color: #9f9f9f;\n  margin-left: 10px;\n}\n.tipsBox span[data-v-6d8266d4] {\n  margin-left: 5px;\n}\n", ""]);

// exports
